module.exports = __webpack_public_path__ + "media/images/like-836c2c0ae10769f2d5d4c910a6c1d308.png";